import {
	Box,
	Divider,
	Logo,
	ResponsiveLayout,
	Stack,
	TelefonicaLogo,
	Text1,
	Text3,
	Text,
	Grid,
	useScreenSize,
	GridItem,
	Image,
	skinVars,
} from "@telefonica/mistica";
import React from "react";
import { strings } from "../../../localization";
import { default as VivoCBF } from "../../../assets/icons/VivoCBF.svg";
import { default as Vivo5G } from "../../../assets/icons/Vivo5G.svg";

export const Footer: React.FC = () => {
	const { isMobile } = useScreenSize();

	return (
		<Box>
			<ResponsiveLayout isInverse className="text-justify">
				<div id="footer">
					<Box paddingBottom={56} paddingTop={56}>
						<Stack space={56} className="text-align-center">
							<Logo type="imagotype" />
							<Text3 regular color={skinVars.colors.textPrimaryInverse}>
								{strings.components.footer.text3}
							</Text3>
						</Stack>

						<Box paddingTop={56}>
							<Box paddingBottom={24} className="text-align-center">
								<Text1 regular color={skinVars.colors.textPrimaryInverse}>
									{strings.components.footer.text1}
								</Text1>
							</Box>
							<Stack space={24}>
								<Divider />
								<Text size={10} color={skinVars.colors.textPrimaryInverse} lineHeight={16}>
									{strings.components.footer.text0}
								</Text>
							</Stack>
						</Box>
					</Box>
				</div>
			</ResponsiveLayout>

			<ResponsiveLayout backgroundColor={skinVars.colors.backgroundAlternative}>
				<Box paddingBottom={40} paddingTop={40}>
					<Stack space={48}>
						<Grid columns={isMobile ? 1 : 3} alignItems="center" justifyItems="center" rows={isMobile ? 3 : 1}>
							<GridItem justifySelf={isMobile ? "center" : "start"}>
								<TelefonicaLogo type="imagotype" size={62} />
							</GridItem>
							<GridItem>
								<Image src={VivoCBF} height={32} width={220} />
							</GridItem>
							<GridItem justifySelf={isMobile ? "center" : "end"}>
								<Image src={Vivo5G} height={32} width={73} />
							</GridItem>
						</Grid>
					</Stack>
				</Box>
			</ResponsiveLayout>
		</Box>
	);
};
